import { FloatingElement, FloatingElementOptions, FloatingPortal, useFloatingElement } from 'library/floating';
import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface TooltipProps
    extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'content'>,
        Pick<FloatingElementOptions, 'open' | 'setOpen' | 'placement' | 'triggers' | 'interactive'> {
    content: ReactNode;
    contentClassName?: string;
}

const Tooltip: FC<TooltipProps> = (props) => {
    const {
        placement = 'top',
        triggers = ['hover'],
        interactive = false,
        children,
        content,
        contentClassName,
        open,
        setOpen,
        className,
        ...rest
    } = props;

    const { context, refs, getReferenceProps, getFloatingProps } = useFloatingElement({
        open,
        setOpen,
        placement,
        triggers,
        interactive,
        offset: 12,
        showArrow: true,
        autoMaxWidth: false,
        autoMaxHeight: false,
    });

    return (
        <>
            <div
                {...rest}
                {...getReferenceProps()}
                ref={refs.setReference}
                className={twMerge(content ? 'cursor-pointer' : '', className)}
            >
                {children}
            </div>

            <FloatingPortal id="tooltip-root">
                {content && (
                    <FloatingElement
                        context={context}
                        refs={refs}
                        {...getFloatingProps()}
                        className={twMerge(
                            'text-sm font-medium px-4 py-2 bg-[#101828] fill-[#101828] dark:bg-[#20262D] dark:fill-[#20262D] text-white rounded-md drop-shadow-[0px_2px_8px_rgba(33,36,48,0.32)] z-50 empty:hidden',
                            contentClassName
                        )}
                    >
                        {content}
                    </FloatingElement>
                )}
            </FloatingPortal>
        </>
    );
};

export default Tooltip;
